module.exports = __webpack_public_path__ + "static/img/10.722c6b2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/6/sp/10.png
// module id = vOJD
// module chunks = 0